import * as yup from "yup";
export const validationSchema = yup.object({
  propertyNumber: yup
    .number("Enter Property Number")
    .typeError("Property Number must be Number")
    .required("Required *"),
  receiptDate: yup.string("").required("Required *"),
  modeOfPayment: yup.string("Select Mode of Payment").required("Required *"),
  // bankName: yup.string("Select Bank Name").required("Required *"),
  txtPaidAmount: yup
    .number("Enter Amount")
    .typeError("Amount Must be Number")
    .min(1, "Must be greater than 0")
    .required("Required *"),
  // bankArea: yup.string("Select Bank Name").required("Required *"),
});

export const reprintReceiptValidationSchema = yup.object({
  propertyNumber: yup
    .number("Enter Property Number")
    .typeError("Property Number must be Number")
    .required("Required *"),
  receiptType: yup.string("Select receipt type").required("Required *"),
});

export const cancelReceiptCashierCounterSchema = yup.object({
  receiptNumber: yup.string("Enter Receipt Number").required("Required *"),
  receiptType: yup.string("Select receipt type").required("Required *"),
  // remark: yup.string("Enter Remark").required("Required *"),
});

export const prefilledChallanValidationSchema = yup.object({
  propertyNumber: yup
    .number("Enter Property Number")
    .typeError("Property Number must be Number")
    .required("Required *"),
  paidAmount: yup
    .number("Paid amount")
    .typeError("Must be Number")
    .required("Required!"),
  noOfBudgetHeads: yup
    .string("No. of Heads")
    .typeError("Select")
    .required("Required!"),
});

export const potkirdBillReceiptSchema = yup.object({
  fromDate: yup.string().required("Required *"),
  toDate: yup.string("").required("Required *"),
  counterName: yup.string("").typeError("Select").required("Required *"),
  modeOfPayment: yup.string("").typeError("Select").required("Required *"),
  zoneKey: yup.string("").typeError("Select").required("Required *"),
});

export const challanSchema = yup.object({
  zoneName: yup.string("").required("Required *"),
  receiptDate: yup.string("").required("Required *"),
});

export const getEDCTxnStatusSchema = yup.object({
  propertyCode: yup.string("").required("Required *"),
  transactionDate: yup.string("").required("Required *"),
});

export const saveStampStockSchema = yup.object({
  zoneName: yup.string("").required("Required *"),
  counterName: yup.string("").required("Required *"),
  receiveDate: yup.string("").required("Required *"),
  costPerStamp: yup.string("").required("Required *"),
  noOfStamp: yup.string("").required("Required *"),
});

export const getStampStockSchema = yup.object({
  zoneName: yup.string("").required("Required *"),
  fromDate: yup.string("").required("Required *"),
  toDate: yup.string("").required("Required *"),
  counter: yup.string("").required("Required *"),
});

export const getZoneWiseReportSchema = yup.object({
  zoneName: yup.string("").required("Required *"),
  modeofPayment: yup.string("").required("Required *"),
  counter: yup.string("").required("Required *"),
  fromDate: yup.string("").required("Required *"),
  toDate: yup.string("").required("Required *"),
});

export const viewChalanSchema = yup.object({
  zoneName: yup.string("").required("Required *"),
  modeOfPayment: yup.string("").required("Required *"),
  counterName: yup.string("").required("Required *"),
  receiptDate: yup.string("").required("Required *"),
});
